"use client";

import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardTitle,
} from "../../components/ui/card";
import { ArrowRight, ArrowLeft } from "lucide-react";
//import Link from "next/link";
import { useNavigate } from "react-router-dom";
import Header from "../../layouts/Header";

const SettingsAbout = () => {
  const navigate = useNavigate();
  const aboutItems = [
    { title: "Privacy Policy", link: "/settings/about/privacy" },
    { title: "Terms of Service", link: "/settings/about/terms" },
  ];

  return (
    <>
      <Header />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        {/* Top Gradient Bar */}
        <div
          className="h-14 bg-gradient-to-r from-blue-600 to-purple-600 flex items-center pl-20 text-white"
          onClick={() => {
            navigate("/settings/index");
          }}
        >
          <ArrowLeft className="mr-5 bg-transparent rounded-full p-1 border-gray-200/60 border hover:border-gray-400 hover:bg-white/20" />
          <p className="text-sm font-medium">Settings / About</p>
        </div>

        {/* Main Content */}
        <div className="flex justify-center mt-8 px-4 md:px-16 lg:px-32">
          <div className="max-w-3xl w-full border-gray-100">
            <Card className="bg-white rounded-2xl shadow-sm">
              <CardHeader className="px-6 pt-6 pb-4">
                <CardTitle className="text-lg font-semibold text-gray-500">
                  About
                </CardTitle>
              </CardHeader>

              <CardContent className="px-6 pb-6 outline outline-gray-50 rounded-md outline-1 pt-5 ml-5 mr-5 mb-5">
                {/* About Items */}
                <div className="space-y-4">
                  {aboutItems.map((item, index) => (
                    <div
                      className="flex items-center justify-between px-4 py-3 bg-white border border-gray-200 rounded-md hover:bg-gray-50 cursor-pointer mb-5"
                      onClick={() => {
                        if (item.title === "Terms of Service") {
                          window.open(
                            "https://80eight.io/app-terms-of-use",
                            "_blank"
                          );
                        } else {
                          window.open(
                            "https://80eight.io/privacy-policy",
                            "_blank"
                          );
                        }
                      }}
                    >
                      <p className="text-sm font-medium text-gray-800">
                        {item.title}
                      </p>
                      <div className="bg-transparent border p-1 rounded-full hover:bg-gray-200 hover:border-gray-500">
                        <ArrowRight className="w-4 h-4 text-gray-500" />
                      </div>
                    </div>
                  ))}
                </div>

                {/* Footer */}
                <div className="flex justify-center mt-8">
                  <p className="text-sm text-gray-500">
                    Questions?{" "}
                    <button
                      className="font-bold text-rose-500 hover:underline cursor-pointer"
                      onClick={() => {
                        navigate("/support/index");
                      }}
                    >
                      Contact us
                    </button>
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsAbout;
